import React, { useState, useEffect } from 'react';
import {
    Box,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    Button,
  
} from '@mui/material';
import RestoreFromTrashIcon from '@mui/icons-material/RestoreFromTrash';
import { branchRecycle, branchRestore } from '../../../Services/Services';

import Popover from '@mui/material/Popover';


const BranchRestore = () => {
    const [branches, setBranches] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [branchToDelete, setBranchToDelete] = useState(null);

    useEffect(() => {
        const branchListApi = async () => {
            try {
                const response = await branchRecycle(); // don't pass any argument if not needed
                setBranches(response);
                console.log("Branches fetched successfully:", response);
            } catch (error) {
                console.error("Error fetching users:", error);
            }
        };

        branchListApi();
    }, []);



    const handleDelete = async (branch_id) => {
        try {
            const response = await branchRestore(branch_id); // don't pass any argument if not needed
            setBranches(response);
        } catch (error) {
            console.error("Error fetching branch:", error);
        }
    };






    return (
        <Box>
            {/* Filter + Sort + Count + Buttons */}

            {branches.length === 0 ? (
                <Typography>No branches found.</Typography>
            ) : (
                <div id="branch-table-print">
                    <TableContainer sx={{ overflowX: "auto", maxWidth: "100%" }}>
                        <Table size="small" sx={{ "& td, & th": { borderBottom: "1px solid #ccc" } }}>
                            <TableHead>
                                <TableRow sx={{ backgroundColor: "#f5f5f5", "& th": { fontWeight: "bold", color: "#333", borderBottom: "1px solid #999", whiteSpace: "nowrap" } }}>
                                    <TableCell align="center">S. No.</TableCell>
                                    <TableCell align="center">Branch ID</TableCell>
                                    <TableCell align="center">Branch Name</TableCell>
                                    <TableCell align="center">Branch Address</TableCell>
                                    <TableCell align="center">Branch Contact No</TableCell>
                                    <TableCell align="center" className="no-print">Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {branches.map((branch, index) => {

                                    return (
                                        <TableRow
                                            key={index}
                                            sx={{
                                                backgroundColor: index % 2 === 0 ? "#fafafa" : "#ffffff", // alternate row color
                                                "& td": {
                                                    paddingTop: "0px",
                                                    paddingBottom: "0px",
                                                    fontSize: "0.8125rem",
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    maxWidth: 120,
                                                    color: (theme) =>
                                                        theme.palette.mode === "dark" ? "white" : "inherit",
                                                    backgroundColor: (theme) =>
                                                        theme.palette.mode === "dark" ? "black" : "inherit",
                                                },
                                            }}
                                        >
                                            <TableCell align="center">{index + 1}</TableCell>
                                            <TableCell align="center">{branch.branch_id}</TableCell>
                                            <TableCell align="center">{branch.branch_name}</TableCell>
                                            <TableCell align="center">{branch.branch_address}</TableCell>
                                            <TableCell align="center">{branch.branch_contact}</TableCell>
                                            <TableCell align="center" className="no-print">
                                                <IconButton
                                                    onClick={(e) => {
                                                        setAnchorEl(e.currentTarget);
                                                        setBranchToDelete(branch.branch_id);
                                                    }}
                                                    color="error"
                                                    size="small"
                                                >
                                                   <RestoreFromTrashIcon fontSize="small" style={{color:"blue"}}/>
                                                </IconButton>

                                             
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            )}



            <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <Box sx={{ p: 1 }}>
                    <Typography variant="body2">Are you sure?</Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
                        <Button
                            color="error"
                            size="small"
                            onClick={async () => {
                                try {
                                    await handleDelete(branchToDelete);
                                } finally {
                                    setAnchorEl(null);
                                    setBranchToDelete(null);
                                }
                            }}
                        >
                            Yes
                        </Button>
                        <Button
                            size="small"
                            onClick={() => {
                                setAnchorEl(null);
                                setBranchToDelete(null);
                            }}
                        >
                            No
                        </Button>
                    </Box>
                </Box>
            </Popover>



        </Box>
    );
};

export default BranchRestore;
